import { lazy, memo, Suspense, useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet-async';
import { Outlet } from 'react-router-dom';
import withRouter from '../../utils/withRouter';
import Loading from '../layouts/Loading';

const Footer = lazy(() => import('../layouts/Footer'));
const Header = lazy(() => import('../layouts/Header'));

ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_CODE);

const Layout = () => {
  useEffect(() => {
    ReactGA.send('pageview', window.location.pathname + window.location.search);
  });

  return (
    <>
      <Helmet>
        <meta property="og:url" content={window.location.href} />
      </Helmet>
      <Suspense fallback={<Loading />}>
        <Header />
      </Suspense>
      <div style={{ minHeight: '50vh' }}>
        <Outlet />
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </>
  );
};

export default withRouter(memo(Layout));
